import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Solutions() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/iremembered/solution_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={793}
              height={671}
            />
          </Col>
          <Col
            xs={12}
            md={5}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#FF6C7F" }}>Solution</span>
            </h2>
            <p>
              The iRemembered app is designed with a minimalistic design while
              keeping the core focus on its functionality. The app comes with a
              wide range of templates that cover greetings, different occasions,
              holidays and a lot more. The customized message option is designed
              to allow users to schedule their unique messages at any time.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
